import {HttpErrorResponse} from "@angular/common/http";
import {createAction, props} from "@ngrx/store";
import {
    ICreateSavedFilterRequestDTO,
    IGetSavedListingFiltersResponseDTO
} from "../save-filters.dto";
import {savedFiltersFeatureKey} from "./saved-filtes.config";

const scope = `[${savedFiltersFeatureKey}]`;

export const resetState = createAction(`${scope} Reset State`);
export const fetchSavedFilters = createAction(`${scope} Fetch Saved Filters`);
export const fetchSavedFiltersSucceeded = createAction(`${scope} Fetch Saved Filters Succeeded`, props<{
    filters: IGetSavedListingFiltersResponseDTO[]
}>());
export const fetchSavedFiltersFailed = createAction(`${scope} Fetch Saved Filters Failed`, props<{
    error: HttpErrorResponse
}>());

export const saveFilters = createAction(`${scope} Save Filters`, props<{ filter: ICreateSavedFilterRequestDTO }>());
export const saveFiltersSucceeded = createAction(`${scope} Save Filters Succeeded`, props<{
    filter: IGetSavedListingFiltersResponseDTO
}>());
export const saveFiltersFailed = createAction(`${scope} Save Filters Failed`, props<{ error: HttpErrorResponse }>());

export const editSavedFilter = createAction(`${scope} Edit Saved Filter`, props<{
    filter: Partial<IGetSavedListingFiltersResponseDTO>
}>());

export const editSavedFilterSucceeded = createAction(`${scope} Edit Saved Filter Succeeded`, props<{
    filter: Partial<IGetSavedListingFiltersResponseDTO>
}>());

export const editSavedFilterFailed = createAction(`${scope} Edit Saved Filter Failed`,  props<{ error: HttpErrorResponse }>());

export const deleteSavedFilter = createAction(`${scope} Delete Saved Filters`, props<{ filterId: number }>());
export const deleteSavedFilterSucceeded = createAction(`${scope} Delete Saved Filters Succeeded`,props<{ filterId: number }>() );
export const deleteSavedFilterFailed = createAction(`${scope} Delete Saved Filters Failed`, props<{ error: HttpErrorResponse }>());

export const filterSelected = createAction(`${scope} Filter Selected`, props<{
    filter: IGetSavedListingFiltersResponseDTO
}>());

export const clearSelectedFilter = createAction(`${scope} Clear Selected Filter`);
